<template>
  <div>
    <!-- <BannerText /> -->
  </div>
</template>

<script>
// import BannerText from "@/components/BannerText.vue";
export default {
  name: "AIStrategy",
  components: {
    // BannerText,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
